module.exports = require("vue");


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 191
// module chunks = 0